import EventEmitter from 'eventemitter3';
import { now } from 'utilities/time';
import { PLAYER_EVENT } from 'constants/events';

export const MAX_EVENT_RETENTION_MS = 5000; // keep previous events for a max of 5 seconds
export const PREVIOUS_EVENT_WHITELIST = [PLAYER_EVENT.AVAILABLE];

export class EventBus extends EventEmitter {
    constructor(...args) {
        super(...args);
        this.previousEvents = {};
        this.previousEventTiming = {};
    }

    emit(eventName, ...args) {
        this.previousEvents[eventName] = args;
        this.previousEventTiming[eventName] = now();
        super.emit(eventName, ...args);

        requestIdleCallback(() => {
            Object
                .keys(this.previousEventTiming)
                .filter(key => !PREVIOUS_EVENT_WHITELIST.includes(key))
                .forEach(key => {
                // delete old events to prevent memory leaks
                if (now() - this.previousEventTiming[key] > MAX_EVENT_RETENTION_MS) {
                    delete this.previousEvents[key];
                    delete this.previousEventTiming[key];
                }
            })
        });
    }

    // subscribe to event and replay last occurrence
    onReplay(eventName, handler) {
        if (this.previousEvents[eventName]) {
            handler(...this.previousEvents[eventName]);
        }

        super.on(eventName, handler);
    }

    any(list, handler) {
        list = Array.isArray(list) ? list : [list];
        list.forEach(i => this.on(i, handler));
        return this;
    }

    toJSON() {
        return []
    }
}